import { OneApi } from '../../components/one-api/one-api';
import { setCurrentLanguage } from './env.slice';

export const EnvMiddlewares = {
  /**
   * Defines current language using OneApi.userAPI
   */
  currentLanguage: () => (next) => (action) => {
    if (action.type === setCurrentLanguage.type) {
      OneApi?.userAPI?.setCurrentLanguage(action.payload.lang);
    }
    return next(action);
  },
};
